import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ad-confirm',
  templateUrl: './ad-confirm.component.html',
  styleUrls: ['./ad-confirm.component.scss']
})
export class AdConfirmComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AdConfirmComponent>) { }

  ngOnInit(): void {
    setTimeout(() => this.dialogRef.close(), 3000);
  }

}
